"use client"; 

import { useState } from "react";

import logger from "../../../lib/logger"
import { capitalize } from "../../../lib/format"
import SourceLogo from "../apps/sourceLogo"
import AppLogo from "../apps/logo"
import FilterBubbles from "../generic/filterBubbles"

import { 
  APP_EXT_ACTIONS_SHOW_MAX_INITIAL, 
  APP_EXT_ACTIONS_LOAD_MORE_CHUNK 
} from "../../../lib/build-constants"
import { classNames } from "../../../lib/helpers";
import SectionMoreButton from "../common/sectionMoreButton";


export default function AppActionsList({ 
  externalActions=[], 
  showMore=false, 
  showFilters=false,
  featuredExternalAppActionIDs=[]
}) {
  logger.info("Component.AppActionsList rendering.");

  if (externalActions?.length === 0) return <></>

  // FUNCTIONS 
  const getAppsUnique = (xActions) => {
    const appsIDsUniq = [... new Set(xActions.map(x => x?.app?.id))]  // Should be 1 or 2  // assuming order will persist
    const appsUniq = appsIDsUniq?.map(id => xActions?.map(x => x?.app)?.find(x => x?.id === id))   
    const appsWithCount = appsUniq?.map(app => ({ ...app, count: xActions?.filter(x => x?.app?.id === app?.id)?.length }))
    // const apps = appsWithCount?.sort((a,b) => (b?.count - a?.count))  // Do not sort, so initial sort prevail and triggerApp will be the first
    const apps = appsWithCount
    return apps
  }

  const getSourcesUnique = (xActions) => {
    const sourcesIDsUniq = [... new Set(xActions?.map(item => item?.source?.id))]
    const sourcesUniq = sourcesIDsUniq?.map(id => xActions?.map(item => item?.source)?.find(x => x?.id === id))
    const sourcesWithCount = sourcesUniq?.map(source => ({ ...source, count: xActions?.filter(x => x?.source?.id === source?.id)?.length }))
    const sources = sourcesWithCount?.sort((a,b) => (b?.count - a?.count))
    return sources
  }  

  const extActionsNamesUniq = (extActions) => {
    const itemsWithNameLowercase = extActions?.map(({ name, ...rest }) => ({ name: name?.toLowerCase(), ...rest })) // name to lowercase 
    const result = [...new Set(itemsWithNameLowercase?.map(x => x?.name))]  // Unique action Names Lisy 
    return result
  }

  const extActionsGrouped = (extActions, options) => {
    const { sortType='desc' } = options
    // GROUP ExtActions BY name, from different sources
    // Then sort by 'type' and 'count_external_automation_actions'
    const currentExtActionsNamesUniq = extActionsNamesUniq(extActions)
    const groupedItems = currentExtActionsNamesUniq?.map(name => {
      const extActionsWithCurrentName = extActions?.filter(x => x?.name?.toLowerCase() === name)
      const countExtAutomActions = extActionsWithCurrentName?.map(x => x?.count_external_automation_actions)?.reduce((partialSum, a) => partialSum + a, 0)
      
      const sourcesIds = [... new Set(extActionsWithCurrentName?.map(x => x?.source?.id))]
      const sources = sourcesIds?.map(id => extActionsWithCurrentName?.map(x => x?.source)?.find(item => item?.id === id))
      const description = extActionsWithCurrentName?.[0]?.description
      const type = extActionsWithCurrentName?.[0]?.type
      const currentApp = extActions?.[0]?.app

      const item = {
        name: capitalize(name), 
        ids: extActionsWithCurrentName?.map(item => item?.id), 
        description: description,
        type: type === 'trigger' ? 'trigger' : 'action', 
        count_external_automation_actions: countExtAutomActions, 
        sources: sources, 
        app: currentApp
      }
      return item
    })
    // const sortedItems = groupedItems?.sort((a, b) => (b?.count_external_automation_actions - a?.count_external_automation_actions))    
    const sortedItems = groupedItems?.sort((a, b) => {
      if (a.type === b.type) {
        return b?.count_external_automation_actions - a?.count_external_automation_actions
      } else {
        const sortTypeNum = sortType==='desc' ? 1 : -1
        return a.type < b.type ? sortTypeNum : -sortTypeNum
      }
    })    

    return sortedItems
  }

  const isExtActionFeatured = (xAction) => {
    const intersection = featuredExternalAppActionIDs.filter(x => xAction.includes(x))
    return intersection?.length >0 ? true : false
  }

  // FILTERING - By Source 
  const [selectedSource, setSelectedSource] = useState(null)
  const sources = getSourcesUnique(externalActions)

  // FILTERING - By App 
  const [selectedApp, setSelectedApp] = useState(null)


  // // Filtering - By ActionType
  // const actionTypes = [
  //   { name: 'Triggers & Actions', slug: 'all', count: 0 },
  //   { name: 'Triggers', slug: 'triggers', count: 0 },
  //   { name: 'Actions', slug: 'actions', count: 0 },    
  // ]
  // const [selectedActionType, setSelectedActionType] = useState(actionTypes[0])  

  // Filtered externalActions
  const externalActionsFilteredBySource = (selectedSource?.id && selectedSource?.slug !== 'all') ? 
    externalActions?.filter(item => item?.source?.id === selectedSource?.id) : externalActions

  const externalActionsFilteredByApp = (selectedApp?.id && selectedApp?.slug !== 'all') ? 
  externalActionsFilteredBySource?.filter(item => item?.app?.id === selectedApp?.id) : externalActionsFilteredBySource

  const externalActionsFiltered = externalActionsFilteredByApp

  // Clculate which apps are in the Filterd set 
  const appsInitial = getAppsUnique(externalActions)
  const apps = getAppsUnique(externalActionsFiltered)


  // TODO 
  // IF there is one APP, then divide by trigegra and actions 
  // IF There are two apps then divide by apps 
  let externalActionsLeft = []
  let externalActionsRight = []
  if (apps?.length === 1) {
    // left triggers - right - actions 
    externalActionsLeft = externalActionsFiltered?.filter(x => x?.type === 'trigger')
    externalActionsRight = externalActionsFiltered?.filter(x => x?.type !== 'trigger')  
  } else {
    externalActionsLeft = externalActionsFiltered?.filter(x => x?.app?.id === apps?.[0]?.id)
    externalActionsRight = externalActionsFiltered?.filter(x => x?.app?.id !== apps?.[0]?.id)
  }

  const [page, setPage] = useState(0)


  const extActionsLeftGrouped = extActionsGrouped(externalActionsLeft, { sortType: 'desc' })  // triggers, then actions
  const extActionsRightGrouped = extActionsGrouped(externalActionsRight, { sortType: 'asc' }) // actions then triggers
  const extActions = [extActionsLeftGrouped, extActionsRightGrouped]

  const maxItems = Math.max(...extActions?.map(item => item?.length))
  const visibleCount = APP_EXT_ACTIONS_SHOW_MAX_INITIAL + page*APP_EXT_ACTIONS_LOAD_MORE_CHUNK

  const extActionDescription = (extAction) => {
    if (!extAction?.description) return  extAction?.name
    let description = extAction?.description
    description = description.replace(/\*\*.*\*\*/,'')  // **Only for [Todoist Premium](https://en.todoist.com/premium) users!** Triggers when you complete a task (including recurring tasks) on a project.
    return description
  }

  // Visible Items 
  const extActionsVisible = extActions?.map(group => group?.slice(0, visibleCount))  // slice both left and right groups
  

  return (
    <>

      {/* FILTERS */}
      {showFilters && (
        <div className="mx-auto bg-gray-100 rounded-md">
          {/* border border-gray-200  */}
          
          {/* Sources filters */}
          <FilterBubbles 
            filterTitle={null}
            items={sources}  
            selectedItem={selectedSource}
            setSelectedItem={setSelectedSource}
            chunk={6}
            chunkInitial={6}
            itemAll={{ name: 'All platforms', slug: 'all', count: 0 }}
          />
          
          {/* APps Filters - only if more than one app */}
          {appsInitial?.length > 1 && (
            <FilterBubbles 
              filterTitle={null}
              items={appsInitial}  
              selectedItem={selectedApp}
              setSelectedItem={setSelectedApp}
              chunk={6}
              chunkInitial={6}
              itemAll={{ name: 'All apps', slug: 'all', count: 0 }}
            />    
          )}    
        </div>
      )}


      {/* EXT ACTIONS GRID */}
      <div className="mb-9 grid grid-cols-1 md:grid-cols-2 gap-x-4 ">
        {extActionsVisible?.map((extActions, groupIndex) => (
          <ul key={groupIndex} role="list" className="col-span-1 ">
            {extActions.map((extAction, index) => (
              <li 
                key={index} 
                className='rounded hover:border-crisp-600 bg-white border border-gray-200 divide-y divide-gray-200 mt-4'
              >                
                <div className="w-full flex items-center justify-between p-3 space-x-4">
                  <div className="flex">
                    <AppLogo app={extAction?.app} className=" h-8 w-8 rounded ring-2 ring-white text-white"/>                                  
                  </div>

                  <div className="flex-1 truncate">
                    <div className="flex items-center space-x-3">
                      <h3 className="text-gray-900 text-lg font-medium truncate">
                        {extAction?.name}
                      </h3>
                    </div>
                    <p className="mt-1 text-base text-gray-500 truncate">
                      {extActionDescription(extAction)}
                    </p>
                  </div>

                  <div className="flex -space-x-3 relative z-0 overflow-hidden">
                    {extAction?.sources?.map((source, index) => (
                      <SourceLogo 
                        key={source?.id} source={source} 
                        className={`relative z-${50-10*index} inline-block h-8 w-8 rounded-full ring-2 ring-white bg-white`}
                      />
                    ))}                    
                  </div>

                </div>
                <div 
                  className={classNames(isExtActionFeatured(extAction?.ids) ? 'bg-crisp-100' : '', 'px-2 py-1 text-xs')}
                >
                  <span className={classNames(extAction?.type === 'trigger' ? 'text-red-800 bg-red-100' : 'text-green-800 bg-green-100', 'flex-shrink-0 inline-block px-2 py-0.5 font-medium rounded-md')}>
                    {extAction?.type}
                  </span>

                  <span className=" text-gray-500 tracking-tight font-medium uppercase flex-shrink-0 inline-block px-2 py-0.5 ">
                    by
                  </span>                  

                  {extAction?.sources?.map((source, index) => (
                    <span key={index} className="mr-1 my-1 flex-shrink-0 inline-block px-2 py-0.5 font-medium text-gray-800 bg-gray-100 rounded-md">
                      {source?.name}
                    </span>
                  ))}                   

                </div>
              </li>
            ))}
          </ul>
        ))}

      </div>

      {showMore && (visibleCount < maxItems) && (
        <SectionMoreButton 
          title="Show more"
          onClick={() => setPage(page + 1)}
        />        
      )}

    </>
  )
}
